import * as no from './no/translation';
import * as en from './en/translation';

const messages = {
  no: {
    translation: no
  },
  en: {
    translation: en
  }
};

export default messages;
